import { Box, HStack, useRadio, useRadioGroup } from "@chakra-ui/react";
import { DarkerTheme } from "../../Styles/colors";

// 1. Create a component that consumes the `useRadio` hook
function RadioCard(props) {
	const { getInputProps, getRadioProps } = useRadio(props);
	const input = getInputProps();
	const checkbox = getRadioProps();
	debugger;
	return (
		<Box as="label">
			<input {...input} />
			<Box
				{...checkbox}
				cursor="pointer"
				borderWidth="1px"
				borderRadius="md"
				boxShadow="md"
				color={DarkerTheme}
				_checked={{
					bg: props.backG ? props.backG : input.name,
					color: "white",
					borderColor: props.backG ? props.backG : input.name,
				}}
				_focus={{
					boxShadow: "outline",
				}}
				px={5}
				py={3}
			>
				{props.children}
			</Box>
		</Box>
	);
}

const RadioComponent = ({ input, reset, getValues, handleValidate }) => {
	const { getRootProps, getRadioProps } = useRadioGroup({
		name: input.inputColor,
		defaultValue: input.options[0],
		onChange: (e) => {
			reset({
				...getValues(),
				[input.id]: e,
			});
			handleValidate();
		},
	});

	const group = getRootProps();

	return (
		<HStack {...group}>
			{input &&
				input.options.map((value) => {
					const radio = getRadioProps({ value });
					return (
						<RadioCard backG={input.name === "Theme Color" && input.inputColor[input.options.indexOf(value)]} key={value} {...radio}>
							{value}
						</RadioCard>
					);
				})}
		</HStack>
	);
};

export default RadioComponent;
